module.exports = __webpack_public_path__ + "img/xcx.c02fff63.png";